const CHECKOUT_PATH_PREFIX = "/cart/checkout"

let holds = 0

/**
 * Marks a flow during which the app must not reload itself (a checkout in
 * flight, a PIX QR on screen, a price review open). Returns the release.
 */
export function holdAppReload(): () => void {
  holds += 1
  let released = false
  return () => {
    if (released) return
    released = true
    holds = Math.max(0, holds - 1)
  }
}

export function isAppReloadHeld(): boolean {
  return holds > 0
}

/** Routes where a reload throws away what the customer is in the middle of. */
export function isAppReloadSafePath(pathname: string): boolean {
  return !pathname.startsWith(CHECKOUT_PATH_PREFIX)
}

/** Reloads the page onto `version`, keeping the current URL. */
export function reloadToVersion(version: string): void {
  const url = new URL(window.location.href)
  url.searchParams.set("mcai_app_version", version)
  if (url.href === window.location.href) {
    window.location.reload()
    return
  }
  window.location.replace(url.href)
}
